import React from 'react';
import Sidebar from '../components/ui/sidebar';
import BackLink from '../components/utils/back-link';

const Tos = () => {
  const today = new Date();
  const year = today.getFullYear();
return (
  <>
    <Sidebar>
        <BackLink/>
    </Sidebar>
  <main className='small-container owl'>

        <p className='txt-bold txt-l -accent txt-uppercase txt-center '>
          Terms of service 
        </p>

      <p className="-accent txt-l">
        Padel++ no te trackea a ti pero monitoriza la salud de la app. Toda actividad que la ponga en peligro no será tolerada, p. ej: 
      </p>

      <p className="-accent txt-l"> <em className="-highlight">1.</em> Intentos de ataque al cloud o al código detrás de esta toy.</p>
      <p className="-accent txt-l"> <em className="-highlight">2.</em> Hyper actividad no-humana aka. bot. </p>
      <p className="-accent txt-l">Esta lista a <em className="-highlight">{year}</em> está abierta a <em className="-highlight">cambios</em>. </p>
  </main>
  </>
); }


export default Tos
